import { render, staticRenderFns } from "./order.vue?vue&type=template&id=eebd79f0&"
import script from "./order.vue?vue&type=script&lang=js&"
export * from "./order.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("F:\\haohao\\QW\\allnet_crm\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('eebd79f0')) {
      api.createRecord('eebd79f0', component.options)
    } else {
      api.reload('eebd79f0', component.options)
    }
    module.hot.accept("./order.vue?vue&type=template&id=eebd79f0&", function () {
      api.rerender('eebd79f0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/order/after-sale-nc/upgrade/components/order.vue"
export default component.exports